import { useMemo } from 'react';
import statusConfig from '@/../config/status.json';
import { useAppContext } from '@/app/providers/AppContextProvider';
import Value from './Value';

const Absence = () => {
	const { appData, isLoading, pendingPremiumVars } = useAppContext();

	const loading = isLoading || !statusConfig.groups.isComplete.includes(appData?.status || '');

	const absenceInfo = useMemo(
		() => appData?.premium_variables?.absence_info || {},
		[appData?.premium_variables?.absence_info]
	);

	const typedAbsenceInfo = absenceInfo as { rates_by_year?: Record<number, number | string> };

	return (
		<span
			// Numbers must never be translated; auto-translate (Chrome/Google Translate)
			// otherwise mutates these text nodes and breaks React reconciliation, making
			// the header collapse to " - %". See issue #747.
			translate="no"
			className="relative font-bold text-base sm:text-sm"
			data-testid="absence-verzuim-container"
		>
			<Value
				index={1}
				loading={loading}
				changedAbsenceValues={pendingPremiumVars.absenceValues}
				absenceInfo={typedAbsenceInfo}
			/>
			<span className="px-1 opacity-25">/</span>
			<Value
				index={2}
				loading={loading}
				changedAbsenceValues={pendingPremiumVars.absenceValues}
				absenceInfo={typedAbsenceInfo}
			/>
			<span className="px-1 opacity-25">/</span>
			<Value
				index={3}
				loading={loading}
				changedAbsenceValues={pendingPremiumVars.absenceValues}
				absenceInfo={typedAbsenceInfo}
			/>
		</span>
	);
};

export default Absence;
